<template>
    <div :class="statusClass">
        <span v-if="status === 'not-started'">Not Started</span>
        <span v-if="status === 'connecting'">Connecting...</span>
        <span v-if="status === 'configuring'">Configuring...</span>
        <span v-if="status === 'success'">Success</span>
        <span v-if="status === 'failure'">Failure</span>
    </div>
</template>

<script>

export default {
    props: {
        status: {
            type: String,
            required: true,
            default: 'not-started',
            validator: (value) => ['not-started', 'connecting', 'configuring', 'success', 'failure'].includes(value)
        }
    },
    computed: {
        statusClass() {
            return {
                'status-indicator': true,
                'not-started': this.status === 'not-started',
                'loading': this.status === 'connecting' || this.status === 'configuring',
                'success': this.status === 'success',
                'failure': this.status === 'failure',
            }
        }
    }
}
</script>

<style>
.status-indicator {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  color: white;
}

.not-started {
  background-color: #6c757d;
}

.loading {
  background-color: #ffc107;
}

.success {
  background-color: #28a745;
}

.failure {
  background-color: #dc3545;
}
</style>